import { httpV1 as http } from '../api';

export async function getCategories(params) {
  return http.get('/cgv/get-vehicle-categories', { params });
}

export async function getBrands(category) {
  return http.get('cgv/get-vehicle-brands', { params: { category } });
}

export async function getModels({ year, brand }) {
  return http.get('/cgv/get-vehicle-models', { params: { brand, year } });
}

export async function getVersions({ year, brand, model }) {
  return http.get('/cgv/get-vehicle-versions', { params: { year, brand, model } });
}

export async function getVehicleByLicense({ license }) {
  return http.get(`/cgv/get-vehicle-by-license?license=${license}`);
}
